import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const ListRoadMap = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [list, setList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  // Fetch roadmap list on mount
  useEffect(() => {
    callAPI("get", "admin/road-maps", "");
  }, []);

  useEffect(() => {
    if (response?.data && statusCode === 200) {
      setList(response.data);
      setIsDelete(false);
    }
  }, [response, statusCode]);

  // Handle delete
  const deleteRecord = (id) => {
    callAPI("delete", `admin/road-maps/${id}`, "");
  };

  useEffect(() => {
    if (statusCode === 204 && !isDelete) {
      toast.success("Roadmap deleted successfully!");
      callAPI("get", "admin/road-maps", "");
      setIsDelete(true);
    }
  }, [statusCode, isDelete]);

  // Filter logic with error-proofing
  const filteredList = list.filter((item) => {
    const programName =
      typeof item.program === "string"
        ? item.program
        : item.program?.name || "";

    const modules = Array.isArray(item.modules) ? item.modules : [];

    return (
      programName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      modules.some(
        (mod) =>
          typeof mod === "string" &&
          mod.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  });

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="RoadMap List"
            subTitle="Manage all created RoadMaps."
          />

          <Link to="/roadmap/add">    <button className="btn">Add RoadMap</button></Link>
          <div className="card shadow-sm mt-4">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <h5 className="mb-0 fw-semibold">All RoadMaps</h5>
                </div>
                <div className="col-md-6 d-flex justify-content-md-end mt-2 mt-md-0">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by program or module"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">#</th>
                    <th className="px-4 py-2">Program</th>
                    <th className="px-4 py-2">Modules</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((item, index) => (
                    <tr key={item.id} className="border-bottom">
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2 fw-semibold">
                        {typeof item.program === "string"
                          ? item.program
                          : item.program?.name || "-"}
                      </td>
                      <td className="px-4 py-2">
                        {Array.isArray(item.modules) && item.modules.length > 0 ? (
                          <div className="d-flex flex-wrap gap-1">
                            {item.modules.map((mod, i) => (
                              <span
                                key={i}
                                className="badge bg-secondary text-light"
                              >
                                {mod}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-muted">No modules</span>
                        )}
                      </td>
                      <td className="px-4 py-2 text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link
                            to={uiRoutes.admin.roadmap.edit.replace(":id", item.id)}
                          >
                            <button
                              className="btn btn-sm btn-outline-primary"
                              title="Edit"
                            >
                              <FaEdit />
                            </button>
                          </Link>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            title="Delete"
                            onClick={() => deleteRecord(item.id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {filteredList.length === 0 && (
                    <tr>
                      <td className="text-center py-4" colSpan="4">
                        No RoadMaps found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ListRoadMap;
